/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import * as req from '_common/utils/req';

import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 提交送付元
   * @returns {Promise<any>}
   */
  fillSenderInfo(params) {
    return new Promise((resolve, reject) => {
      req.postData(
        URL.FILL_SENDER_INFO,
        params,
        (res) => {
          resolve(res.data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  /**
   * 获取当前可充值币种
   * @returns {Promise<any>}
   */
  getCurrendies(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.SUB_CURRENCY_LIST, { params })
        .then((res) => {
          res.data.forEach((item) => {
            const currencyItem = item;
            currencyItem.value = item.currencyId;
            currencyItem.label = item.currency;
            if (
              currencyItem.subCurrencies &&
              currencyItem.subCurrencies.length > 0
            ) {
              currencyItem.subCurrencies.forEach((subItem) => {
                subItem.value = subItem.currencyId;
                subItem.currency = subItem.name;
              });
            }
          });
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /*
   * 获取历史充值地址
   */
  getHistoryAddress(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_DEPOSIT_HISTORY_ADDRESS, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取充值地址
   */
  getAddress(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_DEPOSIT_ADDRESS, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取充值历史
   */
  getHistory(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_DEPOSIT_LIST, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取用户是否可以充值
   */
  getCheckInfo() {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.CHECK_DEPOSIT_LIST)
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
};
